import { TFunction } from "i18next";
import { getTimeSince, TIME_UNITS } from "./date";

export function showNotificationTimeSince(
  timestamp: number | null,
  t: TFunction<"translation", undefined>
) {
  const { days, hours, minutes } = getTimeSince(timestamp, {
    units: [TIME_UNITS.DAYS, TIME_UNITS.HOURS, TIME_UNITS.MINUTES],
  });

  const showDays = days >= 1;
  const showHours = days < 1 && hours >= 1;
  const showMinutes = days < 1 && hours < 1 && minutes >= 1;

  if (showDays) {
    return t("notifications.ageInDays", {
      age: days,
    });
  } else if (showHours) {
    return t("notifications.ageInHours", {
      age: hours,
    });
  } else if (showMinutes) {
    return t("notifications.ageInMinutes", {
      age: minutes,
    });
  } else {
    return t("notifications.ageNow");
  }
}
